
import * as react from "react";
import * as reactRouter from "react-router-dom";

import { Layout, layoutLoader } from "./App.js";

// import { Home, homeLoader } from "./Home.js";
import { Dashboard, dashboardLoader } from "./Dashboard.js";

import { RootErrorBoundary } from "./RootErrorBoundary.js";

import { LoginPage } from "./LoginPage.js";
import { SettingPage } from "./SettingPage.js";

import { TableListManagementPage } from "./TableListManagementPage.js";
import { TableManagementPage } from "./TableManagementPage.js";
import { EditTablePage } from "./EditTablePage.js";

import { ConfigurationFileManagementPage } from "./ConfigurationFileManagementPage.js";
import { EditConfigurationPage } from "./EditConfigurationPage.js";

import { ForgotPasswordPage } from "./ForgotPasswordPage.js";
import { ResetPasswordPage } from "./ResetPasswordPage.js";


export let appRouterDefination = [
    {
        path: "/",
        Component: Layout,
        loader: layoutLoader,
        errorElement: <RootErrorBoundary />,
        children: [
            {
                index: true,
                loader: dashboardLoader,
                Component: Dashboard,
            },
            {
                path: "login",
                Component: LoginPage,
            },
            {
                path: "forgotPassword",
                Component: ForgotPasswordPage,
            },
            {
                path: "resetPassword",
                Component: ResetPasswordPage,
            },
            {
                path: "cpwt",
                Component: ResetPasswordPage,
            },
            {
                path: "setting",
                Component: SettingPage,
            },

            {
                path: "home",
                element: <reactRouter.Navigate to="/" />,
            },
            {
                path: "dashboard",
                element: <reactRouter.Navigate to="/" />,
            },
        ],
    },
];

